import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface User {
  id: string;
  email: string;
  firstName: string;
  lastName?: string;
  photoUrl?: string;
}

interface AuthState {
  user: User | null;
  token: string | null;
  isAuthenticated: boolean;
  setAuth: (user: User, token: string) => void;
  logout: () => void;
}

/**
 * Strip invalid / temporary photo URLs so we always fall back to initials.
 */
function sanitizePhotoUrl(url?: string): string | undefined {
  if (!url) return undefined;
  if (url.includes('t.me/i/userpic')) return undefined;
  return url;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      token: null,
      isAuthenticated: false,
      setAuth: (user, token) =>
        set({
          user: { ...user, photoUrl: sanitizePhotoUrl(user.photoUrl) },
          token,
          isAuthenticated: true,
        }),
      logout: () =>
        set({ user: null, token: null, isAuthenticated: false }),
    }),
    {
      name: 'manifestus-auth',
    }
  )
);
